import { reexported__useFirmAssessments } from "./api/assessmentGetters";
import { usePrefetch } from "@/frontend/@api/usePrefetch";
import { useFirmId } from "@/frontend/firm/FirmProvider";

export const PreloadAssessments = () => {
    const { firmId } = useFirmId();
    usePrefetch(() => reexported__useFirmAssessments(firmId)); // start loading assessments as soon as possible
    return null;
};
